import { getPreSignedUrl, uploadFilesTos3 } from "src/services/upload";
import { UPLOAD_TYPE } from "src/constant/common";

const uploadFile = async (file, uploadType, getPreSignedUrlFunction) => {
  const requestData = {
    file_name: file?.name,
    type: uploadType,
  };

  const presignedUrl = await getPreSignedUrlFunction({ data: requestData });
  const { url, fields } = presignedUrl;

  const filePath = await uploadFilesTos3({ url, fields, file });

  return {
    name: filePath,
    size: file.size,
  };
};

const createBatches = (files, batchSize) => {
  return files.reduce((batches, _, index) => {
    if (index % batchSize === 0) {
      batches.push(files.slice(index, index + batchSize));
    }
    return batches;
  }, []);
};

const batchUpload = async (files, batchSize = 6, uploadType = UPLOAD_TYPE.RAW, getPreSignedUrlFunction = getPreSignedUrl) => {
  const batches = createBatches(files, batchSize);

  const uploadBatch = async (batch) => {
    return Promise.all(batch.map((file) => uploadFile(file, uploadType, getPreSignedUrlFunction)));
  };

  const processBatches = async () => {
    const results = [];
    for (const batch of batches) {
      const batchResults = await uploadBatch(batch);
      results.push(...batchResults);
    }
    return results;
  };

  return processBatches();
};

export default batchUpload;
